// extracted by mini-css-extract-plugin
export default {"adminHeader":"AdminHeader_adminHeader__E9L2G"};